import http from "../http-common";

class AprobadorService {

    ingresar(data) {
        return http.post("/aprobador",data);
    }

    update(id_aprobador, data) {
        return http.put(`/aprobador/${id_aprobador}`,data);
    }
}

export default new AprobadorService();